/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleGroupCheckinStartResponse } from '../../models/bundle-group-checkin-start-response';
import { KeyType } from '../../models/key-type';

export interface CheckinBundleGroup$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
}

export function checkinBundleGroup(http: HttpClient, rootUrl: string, params: CheckinBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroupCheckinStartResponse>> {
  const rb = new RequestBuilder(rootUrl, checkinBundleGroup.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleGroupCheckinStartResponse>;
    })
  );
}

checkinBundleGroup.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/checkin';
